var _path, _rect, _rect2, _rect3, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 485,
    height: 441,
    viewBox: "0 0 485 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163 129C163 74.3238 207.324 30 262 30C316.676 30 361 74.3238 361 129V322H163V129Z",
    fill: "#222222"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    y: 391.33,
    width: 136.352,
    height: 49.6645,
    fill: "#4F74F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 36.1196,
    y: 341.664,
    width: 136.352,
    height: 49.6645,
    fill: "#4F74F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 81.2693,
    y: 292,
    width: 136.352,
    height: 49.6645,
    fill: "#4F74F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M398.398 12.8396C400.94 10.2979 405.06 10.2979 407.602 12.8396L472.16 77.3978C474.702 79.9395 474.702 84.0605 472.16 86.6022L407.602 151.16C405.06 153.702 400.94 153.702 398.398 151.16L333.84 86.6022C331.298 84.0605 331.298 79.9395 333.84 77.3978L398.398 12.8396Z",
    fill: "url(#paint0_linear_148_2096)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.772 98.3999V74.7703H388.618L393.011 79.1638L391.075 81.1002L385.266 75.291L383.32 73.3546L385.256 71.4182L391.066 65.5999L393.002 67.5362L388.517 72.0302H414.522V74.7703H414.503V98.3999H411.772Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_148_2096",
    x1: 450.5,
    y1: 112.5,
    x2: 332,
    y2: -6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F74F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F74F9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro);
export default __webpack_public_path__ + "static/media/intro.1bdd1f6bd78cc5132a4d7cc90eb367f5.svg";
export { ForwardRef as ReactComponent };